export const STATUS = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  ERROR: 500,
  TIMEOUT: 504,
  RATE_LIMIT: 429,
};

export const ERROR_TYPES = {
  STANDARD: 0,
  CONTENT_API: 1,
};
